import { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const blockTypeToBlockName = {
  bullet: 'Bulleted List',
  check: 'Check List',
  code: 'Code Block',
  h1: 'Heading 1',
  h2: 'Heading 2',
  h3: 'Heading 3',
  h4: 'Heading 4',
  h5: 'Heading 5',
  h6: 'Heading 6',
  number: 'Numbered List',
  paragraph: 'Normal',
  quote: 'Quote',
};

const INITIAL_TOOLBAR_STATE = {
  bgColor: '#fff',
  blockType: 'paragraph',
  canRedo: false,
  canUndo: false,
  codeLanguage: '',
  elementFormat: 'left',
  fontColor: '#000',
  fontFamily: 'Arial',
  fontSize: '15px',
  isBold: false,
  isCode: false,
  isHighlight: false,
  isImageCaption: false,
  isItalic: false,
  isLink: false,
  isRTL: false,
  isStrikethrough: false,
  isSubscript: false,
  isSuperscript: false,
  isUnderline: false,
  rootType: 'root',
};

const ToolbarStateContext = createContext(undefined);

export function ToolbarContext({ children }) {
  const [toolbarState, setToolbarState] = useState(INITIAL_TOOLBAR_STATE);

  const updateToolbarState = useCallback((key, value) => {
    setToolbarState((prev) => ({ ...prev, [key]: value }));
  }, []);

  const contextValue = useMemo(
    () => ({ toolbarState, updateToolbarState }),
    [toolbarState, updateToolbarState]
  );

  return (
    <ToolbarStateContext.Provider value={contextValue}>
      {children}
    </ToolbarStateContext.Provider>
  );
}

export function useToolbarState() {
  const context = useContext(ToolbarStateContext);
  if (context === undefined) {
    throw new Error('useToolbarState must be used within a ToolbarContext');
  }
  return context;
}
